import { Flex } from '@mantine/core';
import { IconBrandLine } from '@tabler/icons-react';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import Contacts from 'components/shared/TeamMembersBlock/Contacts';
import Text from 'components/shared/Text';
import { useRootStore } from 'stores/global/RootStore/context';
import { useLkLayoutStore } from 'stores/local/layout/LkLayoutStore';

import s from './TeamResponsible.module.scss';

const TeamResponsible: React.FC = () => {
  const { teamResponsibleStore } = useRootStore();
  const { menu } = useLkLayoutStore();

  const model = teamResponsibleStore.teamResponsible.value;

  if (!model) {
    return null;
  }

  if (!menu.isOpen) {
    return (
      <button className={s.root__iconContainer} onClick={teamResponsibleStore.openDrawer.open}>
        <IconBrandLine size={20} className={s.root__iconContainer__icon} />
      </button>
    );
  }

  return (
    <Flex direction="column" gap="sm" className={s.root}>
      <div>
        <Text fw={600} size="xs">
          {model.name}
        </Text>
        <Text size="xs" c="gray.6">
          {model.jobTitle}
        </Text>
      </div>
      {model.contacts && <Contacts contacts={model.contacts} gapBetweenContacts="sm" isIconVisibleButton={false} />}
    </Flex>
  );
};

export default observer(TeamResponsible);
